import VueI18n from "vue-i18n";

export const i18nFactory = () => {
  return new VueI18n(window.transferState.get("i18n"));
};
